import {ColumnGroupType} from 'antd/es/table';
import {FC, useEffect} from 'react';

import {useCustomTable} from 'components/@common/widgets/custom-table/custom-table';
import {selectContextRawData} from 'modules/context/context-selector';
import {selectTaxForecastsTableData} from 'pages/ais/submit-income-tax-forecast/model/slice';
import {TTaxForecastDto} from 'pages/ais/submit-income-tax-forecast/model/types';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {aisSliceActions} from 'store/slices/ais-slice/ais-slice';

import {taxForecastColumns} from './tax-forecast-table-columns';

export const TaxForecastTable: FC = () => {
    const tableData = useAppSelector(selectTaxForecastsTableData);
    const dispatch = useAppDispatch();
    const {organizationId} = useAppSelector(selectContextRawData) ?? {};

    useEffect(() => {
        dispatch(aisSliceActions.resetTaxForecasts());
    }, [organizationId]);

    const {
        customTableJSX,
    } = useCustomTable<TTaxForecastDto>({
        rowKey: 'id',
        className: 'ais-documents-register-table mt-5',
        locale: {
            emptyText: 'Нет данных',
        },
        dataSource: tableData,
        onColumn: col => ({
            onHeaderCell: (c: ColumnGroupType<TTaxForecastDto>) => {
                if (c.children) {
                    c.children.forEach(child => {
                        child.onHeaderCell = () => ({
                            style: {
                                whiteSpace: 'pre',
                                textAlign: 'center',
                            },
                        });
                    });
                }

                return {
                    style: {
                        whiteSpace: 'pre',
                        textAlign: 'center',
                    },
                };
            },
            ...col,
        }),
        bordered: true,
        columns: taxForecastColumns,
    });

    return customTableJSX;
};
